<template>
  <div class="bottom-map">
    <div class="bottom-item" @click="handleWaterEvent">
      <a-tooltip title="停水事件">
        <div class="icon-wrapper">
          <img src="@/assets/myImg/1/img95.699pic.png" alt="停水事件" />
        </div>
      </a-tooltip>
    </div>
    <div class="bottom-item" @click="handleWaterCutOff">
      <a-tooltip title="停水管控">
        <div class="icon-wrapper">
          <img src="@/assets/myImg/1/停水管控.png" alt="停水管控" />
        </div>
      </a-tooltip>
    </div>
    <div class="bottom-item" @click="handleSearch">
      <a-tooltip title="查询">
        <div class="icon-wrapper">
          <img src="@/assets/myImg/1/icon-ss.png" alt="查询" />
        </div>
      </a-tooltip>
    </div>
    <div class="bottom-item" @click="handlePositioning">
      <a-tooltip title="定位">
        <div class="icon-wrapper">
          <img src="@/assets/myImg/1/定位.png" alt="定位" />
        </div>
      </a-tooltip>
    </div>
    <div class="bottom-item" @click="handleMeasureTool">
      <a-tooltip title="测量">
        <div class="icon-wrapper">
          <img src="@/assets/myImg/1/测量.png" alt="测量" />
        </div>
      </a-tooltip>
    </div>
    <div class="bottom-item" @click="handleAnalyzeTool">
      <a-tooltip title="分析">
        <div class="icon-wrapper">
          <img src="@/assets/myImg/1/工具.png" alt="分析" />
        </div>
      </a-tooltip>
    </div>
    <div class="bottom-item" @click="handleExportTool">
      <a-tooltip title="导出">
        <div class="icon-wrapper">
          <img src="@/assets/myImg/1/导出.png" alt="导出" />
        </div>
      </a-tooltip>
    </div>
    <div class="bottom-item" @click="handleLegend">
      <a-tooltip title="图例">
        <div class="icon-wrapper">
          <img src="@/assets/myImg/1/图例.png" alt="图例" />
        </div>
      </a-tooltip>
    </div>

    <div class="select-wrapper">
      <a-select v-model="selectedValue" placeholder="选择图层" style="width: 120px" size="small"
        @change="handleSelectChange" :getPopupContainer="(triggerNode) => triggerNode.parentNode">
        <a-select-option value="layer1">高德矢量</a-select-option>
        <a-select-option value="layer2">高德影像</a-select-option>
        <a-select-option value="layer3">天地影像</a-select-option>
        <a-select-option value="layer4">必应地图</a-select-option>
      </a-select>
    </div>


    <!-- 查询抽屉组件 -->
    <QueryDrawer :visible="queryVisible" @close="handleQueryClose" @query-search="handleQuerySearch"
      @clear-layer="handleClearLayer" @location-map="handleLocationMap" />

    <!-- 停水管控抽屉组件 -->
    <WaterCutOff :visible="waterCutOffVisible" :pipeline-id="currentPipelineId" :pipeline-feature="currentPipelineFeature" @close="handleWaterCutOffClose"
      @filter-change="handleFilterChange" @display-valve="handleDisplayValve"
      @cancel-display-valve="handleCancelDisplayValve" @show-affected-users="handleShowAffectedUsers"
      @clear-all-layers="handleClearAllLayers" @update-selected-valves="handleUpdateSelectedValves" />
  </div>
</template>
<script>
import QueryDrawer from '../newBigMapModule/queryDrawer.vue'
import WaterCutOff from './WaterCutOff.vue'
export default {
  name: 'BottomMap',
  components: {
    QueryDrawer,
    WaterCutOff
  },
  data () {
    return {
      selectedValue: 'layer4',
      queryVisible: false,
      waterCutOffVisible: false,
      currentPipelineId: '', // 当前选中的管线ID
      currentPipelineFeature: null, // 当前选中的管线要素数据
      // 地图图层配置对象，包含URL、坐标系和缩放级别信息
      mapLayerConfigs: {
        layer1: {
          name: '高德矢量',
          url: 'https://wprd0{1-4}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&style=7&x={x}&y={y}&z={z}',
          projection: 'GCJ-02',  // 高德地图使用火星坐标系
          maxZoom: 18  // 最大缩放级别
        },
        layer2: {
          name: '高德影像',
          url: 'https://webst01.is.autonavi.com/appmaptile?style=6&x={x}&y={y}&z={z}',
          projection: 'GCJ-02',  // 高德地图使用火星坐标系
          maxZoom: 16  // 最大缩放级别
        },
        layer3: {
          name: '天地影像',
          url: 'https://t7.tianditu.gov.cn/DataServer?T=img_w&x={x}&y={y}&l={z}&tk=485cd3a62955d7a962a5c0d64d4949f2',
          projection: 'EPSG:3857',  // 天地图使用标准Web墨卡托投影
          maxZoom: 18  // 最大缩放级别
        },
        layer4: {
          name: '必应地图',
          useTileUrlFunction: true,  // 标识需要使用自定义瓦片URL函数
          projection: 'GCJ-02',  // 必应地图使用火星坐标系
          maxZoom: 18  // 最大缩放级别
        }
      }
    }
  },
  methods: {
    //查询
    handleSearch () {
      // 打开查询抽屉时，关闭停水管控抽屉
      if (!this.queryVisible) {
        this.waterCutOffVisible = false;
      }
      this.queryVisible = !this.queryVisible;
    },
    //停水事件
    handleWaterEvent () {
      // 触发停水事件切换事件，由父组件处理
      this.$emit('water-event-toggle');

      // 关闭其他抽屉
      this.queryVisible = false;
      this.waterCutOffVisible = false;
    },
    //停水管控
    handleWaterCutOff () {
      // 打开停水管控抽屉时，关闭查询抽屉
      if (!this.waterCutOffVisible) {
        this.queryVisible = false;
      }
      this.waterCutOffVisible = !this.waterCutOffVisible;
    },
    // 关闭停水管控抽屉
    handleWaterCutOffClose () {
      this.waterCutOffVisible = false;
      this.currentPipelineId = ''; // 清空管线ID
      this.currentPipelineFeature = null; // 清空管线要素数据
    },
    // 关闭查询抽屉
    handleQueryClose () {
      this.queryVisible = false;
    },

    // 处理查询搜索事件
    handleQuerySearch (queryParams) {
      console.log('接收到查询事件:', queryParams)

      // 将查询事件传递给父组件
      this.$emit('query-search', queryParams);
    },

    // 处理清除图层事件
    handleClearLayer (layerId) {
      console.log('接收到清除图层事件:', layerId);
      // 将清除图层事件传递给父组件
      this.$emit('clear-layer', layerId);
    },

    // 处理地图定位事件
    handleLocationMap (locationData) {
      console.log('接收到地图定位事件:', locationData);
      // 将定位事件传递给父组件
      this.$emit('location-map', locationData);
    },

    //定位
    handlePositioning () {
      this.$emit('positioning');
    },

    //测量工具
    handleMeasureTool () {
      this.$emit('tool-click', 'measure');
    },

    //分析工具
    handleAnalyzeTool () {
      this.$emit('tool-click', 'analyze');
    },

    //导出工具
    handleExportTool () {
      this.$emit('tool-click', 'export');
    },

    //图例
    handleLegend () {
      this.$emit('show-legend');
    },
    handleSelectChange (value) {
      console.log('选择的图层:', value)

      // 获取对应的地图配置
      const selectedConfig = this.mapLayerConfigs[value]
      console.log('对应的地图配置:', selectedConfig)

      // 构建地图配置对象
      const config = {
        layerType: value,
        mapUrl: selectedConfig.url,
        projection: selectedConfig.projection,
        layerName: selectedConfig.name,
        maxZoom: selectedConfig.maxZoom
      }

      // 如果是必应地图，添加自定义瓦片URL函数
      if (selectedConfig.useTileUrlFunction) {
        config.tileUrlFunction = this.getBingTileUrlFunction()
      }

      // 向父组件传递完整的地图配置（包括URL、坐标系和缩放级别）
      this.$emit('layer-change', config)
    },

    // 必应地图瓦片URL函数
    getBingTileUrlFunction () {
      return (coord) => {
        return this.getVETileUrl(coord[0], coord[1], coord[2])
      }
    },

    // 必应地图瓦片URL生成器
    getVETileUrl (z, x, y) {
      let quadKey = ''
      let tileX = x
      let tileY = y

      for (let i = 0; i < z; i++) {
        quadKey = ((tileX & 1) + 2 * (tileY & 1)).toString() + quadKey
        tileX >>= 1
        tileY >>= 1
      }

      return 'http://dynamic.t0.tiles.ditu.live.com/comp/ch/' + quadKey + '?it=G,VE,BX,L,LA&mkt=zh-cn,syr&n=z&og=111&ur=CN'
    },

    // 打开停水管控抽屉（供外部调用）
    openWaterCutOff (pipelineId, feature) {
      console.log('打开停水管控抽屉');
      console.log('管线ID:', pipelineId);
      console.log('要素数据:', feature);

      // 保存管线ID和要素数据
      this.currentPipelineId = pipelineId;
      this.currentPipelineFeature = feature || null;

      // 先关闭查询抽屉
      this.queryVisible = false;

      // 打开停水管控抽屉
      this.waterCutOffVisible = true;
    },

    // 处理筛选变化事件
    handleFilterChange (data) {
      console.log('BottomMap 接收到筛选变化事件:', data);
      // 透传给父组件
      this.$emit('filter-change', data);
    },

    // 处理展示阀门事件
    handleDisplayValve (record) {
      console.log('BottomMap 接收到展示阀门事件:', record);
      // 透传给父组件
      this.$emit('display-valve', record);
    },

    // 处理取消展示阀门事件
    handleCancelDisplayValve () {
      console.log('BottomMap 接收到取消展示阀门事件');
      // 透传给父组件
      this.$emit('cancel-display-valve');
    },

    // 处理显示受影响用户事件
    handleShowAffectedUsers (data) {
      console.log('BottomMap 接收到显示受影响用户事件:', data);
      // 透传给父组件
      this.$emit('show-affected-users', data);
    },

    // 处理清除所有图层事件
    handleClearAllLayers () {
      console.log('BottomMap 接收到清除所有图层事件');
      // 透传给父组件
      this.$emit('clear-all-layers');
    },

    // 处理更新已选中阀门事件
    handleUpdateSelectedValves (selectedValves) {
      console.log('BottomMap 接收到更新已选中阀门事件:', selectedValves);
      // 透传给父组件
      this.$emit('update-selected-valves', selectedValves);
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .ant-select-dropdown {
  top: -130px !important;
  left: 400px !important;
}

.bottom-map {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 20px;
  z-index: 1000;
  display: flex;
  gap: 8px;
  background: rgba(255, 255, 255, 0.95);
  //backdrop-filter: blur(10px);
  border-radius: 12px;
  padding: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;

  &:hover {
    transform: translateX(-50%) translateY(-2px);
    box-shadow: 0 6px 25px rgba(0, 0, 0, 0.2);
  }
}

.bottom-item {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;

  &:hover {
    background: rgba(24, 144, 255, 0.1);
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(24, 144, 255, 0.1), rgba(24, 144, 255, 0.05));
    opacity: 0;
    transition: opacity 0.2s ease;
    border-radius: 8px;
  }

  &:hover::before {
    opacity: 1;
  }
}

.icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  position: relative;
  z-index: 1;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    filter: brightness(0.4) grayscale(1);
    transition: filter 0.2s ease;
  }
}

.bottom-item:hover .icon-wrapper img {
  filter: brightness(1) saturate(1.2);
}

// 响应式设计
@media (max-width: 768px) {
  .bottom-map {
    bottom: 10px;
    padding: 6px;
    gap: 6px;
  }

  .bottom-item {
    width: 36px;
    height: 36px;
  }

  .icon-wrapper {
    width: 20px;
    height: 20px;
  }
}

// 动画效果
@keyframes pulse {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
  }
}

.bottom-item:active {
  animation: pulse 0.3s ease;
}

// 选择器样式
.select-wrapper {
  display: flex;
  align-items: center;
  margin-left: 8px;

  :deep(.ant-select) {
    .ant-select-selector {
      background: rgba(255, 255, 255, 0.95) !important;
      border: 1px solid rgba(24, 144, 255, 0.3) !important;
      border-radius: 8px !important;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
      transition: all 0.2s ease !important;

      &:hover {
        border-color: #1890ff !important;
        box-shadow: 0 4px 12px rgba(24, 144, 255, 0.15) !important;
      }
    }

    .ant-select-selection-placeholder {
      color: #999;
      font-size: 12px;
    }

    .ant-select-selection-item {
      color: #1890ff;
      font-weight: 500;
      font-size: 12px;
    }
  }

  :deep(.ant-select-arrow) {
    color: #1890ff;
    font-size: 10px;
  }
}

// 响应式设计 - 选择器
@media (max-width: 768px) {
  .select-wrapper {
    margin-left: 4px;

    :deep(.ant-select) {
      width: 100px !important;

      .ant-select-selector {
        height: 32px !important;
      }
    }
  }
}
</style>